import PropTypes from "prop-types";

export const ChargeItemData = PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    taxes: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
});
export const SummaryDetailData = PropTypes.shape({
    total: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    taxes: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(ChargeItemData).isRequired,
    groups: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        types: PropTypes.arrayOf(PropTypes.string.isRequired)
    }))
});
